// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --grexel-sidebar: #0e5466;
  --grexel-active: #0c4352;
  --grexel-bg: #f8fafc;
  --grexel-border: #e2e8f0;
  --grexel-text: #334155;
  --grexel-accent: #0ea5e9;
  --grexel-table-header: #f1f5f9;
  --glass: white;
  --glass-border: #e2e8f0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  background-color: var(--grexel-bg);
  color: var(--grexel-text);
  -webkit-font-smoothing: antialiased;
}

/* Enterprise Layout */
.sidebar-bg {
  background-color: var(--grexel-sidebar);
}

.glass {
  background: white;
  border-bottom: 1px solid var(--grexel-border);
}

.glass-card {
  background: white;
  border: 1px solid var(--grexel-border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.full-input {
  width: 100%;
  padding: 0.75rem;
  background: white !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 4px;
  color: #1e293b !important;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.full-input:focus {
  border-color: var(--grexel-accent) !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
  outline: none;
}

/* Enterprise Data Tables */
.ent-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.ent-table th {
  background: var(--grexel-table-header);
  padding: 12px 16px;
  text-align: left;
  font-weight: 700;
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid var(--grexel-border);
}

.ent-table td {
  padding: 14px 16px;
  border-bottom: 1px solid var(--grexel-border);
  font-size: 13px;
}

.ent-table tr:hover {
  background-color: #f8fafc;
}

/* Badge Styles */
.badge {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.badge-success {
  background: #dcfce7;
  color: #166534;
}

.badge-warning {
  background: #fef9c3;
  color: #854d0e;
}

.badge-info {
  background: #e0f2fe;
  color: #075985;
}

/* Progress/Tabs Header (Grexel Style) */
.step-header {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 20px;
  border-bottom: 1px solid var(--grexel-border);
  margin-bottom: 40px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.5;
}

.step-item.active {
  opacity: 1;
  color: var(--grexel-sidebar);
}

.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

.btn-grexel {
  background: #155e75;
  color: white;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-grexel:hover {
  background: #0e4e61;
}

/* Shepherd.js Premium Theme Overrides */
.shepherd-element.custom-shepherd-theme {
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
  border: 1px solid #e2e8f0;
  max-width: 400px;
  padding: 1rem;
}

.shepherd-title {
  color: #0f172a;
  font-family: 'Outfit', sans-serif;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  font-size: 1.125rem;
  padding: 1rem 1.5rem 0.5rem;
}

.shepherd-text {
  color: #475569;
  font-size: 0.875rem;
  line-height: 1.6;
  padding: 0.5rem 1.5rem 1.5rem;
}

.shepherd-button-primary {
  background: #155e75 !important;
  color: white !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  font-size: 0.75rem !important;
  padding: 0.75rem 1.5rem !important;
  border-radius: 0.75rem !important;
  transition: all 0.2s !important;
  margin-right: 0.5rem !important;
}

.shepherd-button-secondary {
  background: #f1f5f9 !important;
  color: #64748b !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  font-size: 0.75rem !important;
  padding: 0.75rem 1.5rem !important;
  border-radius: 0.75rem !important;
}

.shepherd-arrow:before {
  background: white !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oDAAoD;EACpD,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --grexel-sidebar: #0e5466;\n  --grexel-active: #0c4352;\n  --grexel-bg: #f8fafc;\n  --grexel-border: #e2e8f0;\n  --grexel-text: #334155;\n  --grexel-accent: #0ea5e9;\n  --grexel-table-header: #f1f5f9;\n  --glass: white;\n  --glass-border: #e2e8f0;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background-color: var(--grexel-bg);\n  color: var(--grexel-text);\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Enterprise Layout */\n.sidebar-bg {\n  background-color: var(--grexel-sidebar);\n}\n\n.glass {\n  background: white;\n  border-bottom: 1px solid var(--grexel-border);\n}\n\n.glass-card {\n  background: white;\n  border: 1px solid var(--grexel-border);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.full-input {\n  width: 100%;\n  padding: 0.75rem;\n  background: white !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 4px;\n  color: #1e293b !important;\n  font-size: 0.875rem;\n  transition: all 0.2s;\n}\n\n.full-input:focus {\n  border-color: var(--grexel-accent) !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);\n  outline: none;\n}\n\n/* Enterprise Data Tables */\n.ent-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.ent-table th {\n  background: var(--grexel-table-header);\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 700;\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid var(--grexel-border);\n}\n\n.ent-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--grexel-border);\n  font-size: 13px;\n}\n\n.ent-table tr:hover {\n  background-color: #f8fafc;\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.badge-success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.badge-warning {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.badge-info {\n  background: #e0f2fe;\n  color: #075985;\n}\n\n/* Progress/Tabs Header (Grexel Style) */\n.step-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  padding: 20px;\n  border-bottom: 1px solid var(--grexel-border);\n  margin-bottom: 40px;\n}\n\n.step-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  opacity: 0.5;\n}\n\n.step-item.active {\n  opacity: 1;\n  color: var(--grexel-sidebar);\n}\n\n.step-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out forwards;\n}\n\n.btn-grexel {\n  background: #155e75;\n  color: white;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.btn-grexel:hover {\n  background: #0e4e61;\n}\n\n/* Shepherd.js Premium Theme Overrides */\n.shepherd-element.custom-shepherd-theme {\n  background: white;\n  border-radius: 1.5rem;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);\n  border: 1px solid #e2e8f0;\n  max-width: 400px;\n  padding: 1rem;\n}\n\n.shepherd-title {\n  color: #0f172a;\n  font-family: 'Outfit', sans-serif;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: -0.01em;\n  font-size: 1.125rem;\n  padding: 1rem 1.5rem 0.5rem;\n}\n\n.shepherd-text {\n  color: #475569;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  padding: 0.5rem 1.5rem 1.5rem;\n}\n\n.shepherd-button-primary {\n  background: #155e75 !important;\n  color: white !important;\n  font-weight: 800 !important;\n  text-transform: uppercase !important;\n  font-size: 0.75rem !important;\n  padding: 0.75rem 1.5rem !important;\n  border-radius: 0.75rem !important;\n  transition: all 0.2s !important;\n  margin-right: 0.5rem !important;\n}\n\n.shepherd-button-secondary {\n  background: #f1f5f9 !important;\n  color: #64748b !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  font-size: 0.75rem !important;\n  padding: 0.75rem 1.5rem !important;\n  border-radius: 0.75rem !important;\n}\n\n.shepherd-arrow:before {\n  background: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
